<template>
  <v-card>
    <v-card-title>
          <router-link :to="{ name: 'Groups_add'}">
            <v-icon small  class="mr-2"> add </v-icon>
          </router-link>      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="getheaers"
      :items="list"
      :search="search"
      :options.sync="pagination"
      :rowsPerPageItems="rowsPerPageItems"
    >
      <template v-slot:items="props">
        <td class="justify-center">
          <router-link :to="{ name: 'Groups_edit', params: { id: props.item.gid }}">
            <v-icon small  class="mr-2"> edit </v-icon>
          </router-link>
        </td>
        <td class="text-xs-right"> {{ props.item.gid}} </td>
        <td class="text-xs-right"> {{ props.item.gname }} </td>
        <td class="text-xs-right"> {{ props.item.gdesc }} </td>  

      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        schema: [],
        list: [], 
        headers: [],
        rowsPerPageItems: [10, 20, 40, 80 ,160, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
        pagination: {
            rowsPerPage: 40,
        },
      }
    },
      mounted() {
      if(localStorage.getItem('access_token')!=null){ this.$http.defaults.headers.common['X-Authorization'] =  localStorage.getItem('access_token');}
       this.$http
      .get(this.$root.apiUrl+'/api/v1/schemas/groups.json')
      .then(response => (this.schema = response.data)).then(console.log(this.schema));
      this.$http.get(this.$root.apiUrl+'/api/v1/groups/').then(response => (this.list = response.data.result));

  },
    computed: {
    getheaers: function () {
        var obj1=[];
        obj1.push({ text: 'Actions', value: 'name', sortable: false })
        for ( var key in this.schema.properties) {
          if(this.schema.properties[key]['x-list']){
            obj1.push({ text: this.schema.properties[key].title, value: key, align: 'right', });
        }}
      return obj1
    }
  },
  methods: {
  	log: function(a) {
    	console.log(a);
    }
  }
  }
</script>
<style>

table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 5px;
}
table.v-table tbody td, table.v-table tbody th {
    height: 1px;
}
</style>


// WEBPACK FOOTER //
// src/pages/groups/list.vue